module.exports = __webpack_public_path__ + "../resources/img/ic_re_pi_battery_left_view.8b444107.svg";